import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  Typography,
  CircularProgress,
  Divider,
  MenuItem
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { createRoute } from 'src/store/actions/RouteManagerActions';
import { getRouteCategoryAction } from 'src/store/actions/RouteCategoryActions';

function CreateRoute({ open, handleClose }) {
  const profile = JSON.parse(sessionStorage.getItem('profile'));
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const routeCategories = useSelector(
    (state) => state.RouteCategories.routeCategories
  );

  const handleCreateRoute = async (values) => {
    setLoading(true);
    const response = await dispatch(createRoute(values, profile));
    if (response === 1) {
      setLoading(false);
      handleClose();
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(getRouteCategoryAction('', profile));
  }, []);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Typography color="textPrimary" variant="h2">
          Create Route
        </Typography>
      </DialogTitle>
      <Divider />
      <Formik
        initialValues={{
          route: '',
          datafull: '',
          // dataless: '',
          // failed: '',
          name: '',
          routeCategoryID: '',
          issuerID: null,
          method: ''
        }}
        validationSchema={Yup.object().shape({
          route: Yup.string().trim().max(255).required('Route is required'),
          datafull: Yup.string()
            .trim()
            .max(255)
            .required('User ID is required'),
          // dataless: Yup.string()
          //   .trim()
          //   .max(255)
          //   .required('User Secret key is required'),
          // failed: Yup.string()
          //   .trim()
          //   .max(255)
          //   .required('User Secret key is required'),
          name: Yup.string().trim().max(255).required('Name is required'),
          routeCategoryID: Yup.string()
            .trim()
            .max(255)
            .required('Please select a category'),
          method: Yup.string().required('Method is required')
        })}
        onSubmit={(values) => {
          handleCreateRoute(values);
          // navigate('/app/dashboard', { replace: true });
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values
        }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <TextField
                error={Boolean(touched.name && errors.name)}
                fullWidth
                helperText={touched.name && errors.name}
                label="Name"
                margin="dense"
                name="name"
                onBlur={handleBlur}
                onChange={handleChange}
                type="text"
                value={values.name}
                variant="outlined"
                size="small"
              />
              <TextField
                error={Boolean(touched.route && errors.route)}
                fullWidth
                helperText={touched.route && errors.route}
                label="Route"
                margin="dense"
                name="route"
                onBlur={handleBlur}
                onChange={handleChange}
                type="text"
                value={values.route}
                variant="outlined"
                size="small"
              />

              <TextField
                fullWidth
                select
                margin="normal"
                name="routeCategoryID"
                label="Select Category"
                required
                variant="outlined"
                size="small"
                onChange={handleChange}
                value={values.routeCategoryID}
              >
                <MenuItem value="">Please select category</MenuItem>
                {routeCategories.map((item, index) => (
                  <MenuItem key={index} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                select
                margin="normal"
                name="method"
                label="Select Method"
                required
                variant="outlined"
                size="small"
                onChange={handleChange}
                value={values.method}
              >
                <MenuItem value="POST">POST</MenuItem>
                <MenuItem value="GET">GET</MenuItem>
                <MenuItem value="PUT">PUT</MenuItem>
                <MenuItem value="DELETE">DELETE</MenuItem>
              </TextField>
              <TextField
                error={Boolean(touched.datafull && errors.datafull)}
                fullWidth
                helperText={touched.datafull && errors.datafull}
                label="Cost"
                margin="dense"
                name="datafull"
                onBlur={handleBlur}
                onChange={handleChange}
                type="text"
                value={values.datafull}
                variant="outlined"
                size="small"
              />
              {/* <TextField
                error={Boolean(touched.dataless && errors.dataless)}
                fullWidth
                helperText={touched.dataless && errors.dataless}
                label="Incomplete Fetch Cost"
                margin="dense"
                name="dataless"
                onBlur={handleBlur}
                onChange={handleChange}
                type="text"
                value={values.dataless}
                variant="outlined"
                size="small"
              />
              <TextField
                error={Boolean(touched.failed && errors.failed)}
                fullWidth
                helperText={touched.failed && errors.failed}
                label="Failed Fetch Cost"
                margin="dense"
                name="failed"
                onBlur={handleBlur}
                onChange={handleChange}
                type="text"
                value={values.failed}
                variant="outlined"
                size="small"
              /> */}
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" onClick={handleClose}>
                Close
              </Button>
              <Button
                disabled={loading}
                variant="contained"
                color="primary"
                type="submit"
              >
                {loading && <CircularProgress size="1.5rem" />}
                Create Route
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}

export default CreateRoute;
